export default __webpack_public_path__ + "static/media/app-icon.1b516659.svg";